import liff from '@line/liff'

let initialized = false

export async function initLiff(): Promise<void> {
  if (initialized) return

  const liffId = import.meta.env.VITE_LIFF_ID
  if (!liffId) {
    console.warn('[LIFF] VITE_LIFF_ID not set — running in dev mode')
    initialized = true
    return
  }

  await liff.init({ liffId })
  initialized = true
}

export function getLiffProfile() {
  if (!liff.isLoggedIn()) return null
  return liff.getProfile()
}

export function isInLiff(): boolean {
  return liff.isInClient()
}

export function isLoggedIn(): boolean {
  try {
    return liff.isLoggedIn()
  } catch {
    return false
  }
}

export function loginWithLine(): void {
  liff.login()
}

export function getLineAccessToken(): string | null {
  try {
    return liff.getAccessToken()
  } catch {
    return null
  }
}

export { liff }
